import DialogsContext from './DialogsContext'

const DialogsConsumer = DialogsContext.Consumer ;

export default DialogsConsumer ;